import { makeAutoObservable } from "mobx";
import { delay } from "src/common/delay";
import { cvtError } from "src/common/onError";
import { RemoteData } from "src/common/RemoteData";
import { multiStepOnRowClick } from "src/components/MultiStepTask/utils";
import { EntityFiltersPageStore } from "src/pages/EntityFiltersPage/EntityFiltersPageStore";
import { ZUid } from "src/types/zUid";
import { copyBom3 } from "../../apiBom3";

type ParamsBom3CopyIn = {
  bomEntityIdsFrom: ZUid[];
  modelObjectId: ZUid;
  close(): void;
  onFinish(): void;
};

export class Bom3CopyInStore {
  constructor(public readonly params: ParamsBom3CopyIn) {
    this.entitiesStore = new EntityFiltersPageStore({
      objectId: params.modelObjectId,
      selectionSettings: { selectionType: "checkbox" },
      onRowClick: (row) => multiStepOnRowClick(row, this.entitiesStore),
    });
    makeAutoObservable(this);
  }

  get disabled(): boolean {
    return !this.entitiesStore.tableStore?.selected.length;
  }

  // step-1
  entitiesStore: EntityFiltersPageStore;

  // --- copy
  copyInfo: RemoteData<boolean> = { status: "none" };

  setCopyInfo(data: RemoteData<boolean>) {
    this.copyInfo = data;
  }

  async copy() {
    try {
      this.setCopyInfo({ status: "wait" });

      const modelEntityIdsTo =
        this.entitiesStore.tableStore?.selected.map(({ id }) => id) ?? [];
      await copyBom3(this.params.bomEntityIdsFrom, modelEntityIdsTo);

      this.setCopyInfo({ status: "ready", result: true });
      this.params.onFinish();

      await delay(1000);
      this.params.close();
    } catch (e) {
      this.setCopyInfo({ status: "error", error: cvtError(e) });
    }
  }
}
